$('.cstmAtc').on('submit', function (e){
    e.preventDefault();
    var varid = $(this).find('input[name="id"]').val();
var $this= $(this).find('.atc-alert');
  var flag;  
  flag = addItemToCart(varid, 1);

setTimeout(function() {
    console.log('flag ',flag)
    // if(flag == true){
    //   $this.show(100).delay(2000).hide(1000);
    // }else{
       $this.show(100).delay(2000).hide(1000);
    // }
    }, 2000);   

})
    var successmsg = false;
  function addItemToCart(variant_id, qty) {

    var data = {
      "id": variant_id,
      "quantity": qty
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(cart) { 
       if ($('#cart-icon-bubble').children('.cart-count-bubble').length > 0){
          $('.cart-count-bubble').load(location.href + ' .cartcount');
      }else{
              $('#cart-icon-bubble').append('<div class="tempss"></div>');
              $('.tempss').load(location.href + ' .cart-count-bubble');
              $('.cart-count-bubble').show();
      }
          successmsg=true;
           
      }

    });
   
     return successmsg;
  }